import player from "./player";
import Product from "./product";
import videoPlayer from "./videoPlayer";

class ProductVideo extends Product {
	init() {
		super.init();
		const jsProduct = this.jsProduct;
		const jsPlayVideo = jsProduct.querySelectorAll<HTMLElement>(
			`.jsPlayVideo`
		);

		jsPlayVideo.forEach((jsPlayVideo) => {
			const jsVideo = jsPlayVideo.parentNode?.querySelector<HTMLVideoElement>(
				".jsVideo"
			)!;
			const handler = () => {
				const videoId = parseInt(jsVideo.dataset.id + "");
				const activeVideoId = videoPlayer.props.videoId;
				if (videoId === activeVideoId) {
					this.togglePlay(jsVideo);
				} else {
					this.play(jsVideo);
				}
			};

			this.addEventListener({
				node: jsPlayVideo,
				event: "click",
				handler: handler,
			});
		});
		// STR jsPlayMainVideo
		const jsPlayMainVideo_Items = jsProduct.querySelectorAll<HTMLElement>(
			`.jsPlayMainVideo`
		);
		const playMainVideoHandler = () => {
			if (this.state.contentUploaded !== true) {
				const jsVideoFirst = jsProduct.querySelector<HTMLVideoElement>(
					".jsVideo"
				);
				if (!jsVideoFirst) {
					const refreshIntervalId = setInterval(() => {
						if (this.state.contentUploaded === true) {
							const jsVideo = jsProduct.querySelector<HTMLVideoElement>(
								".jsVideo"
							);
							clearInterval(refreshIntervalId);
							jsVideo?.click();
						}
					}, 1000);
				}
			} else {
				videoPlayer.togglePlay();
			}
		};
		jsPlayMainVideo_Items.forEach((jsPlayMainVideo) => {
			this.addEventListener({
				node: jsPlayMainVideo,
				event: "click",
				handler: playMainVideoHandler,
			});
		});
		// END jsPlayMainVideo

		return false;
	}
	play(jsVideo: HTMLVideoElement) {
		// console.log("play jsVideo", jsVideo);
		const videoId = parseInt(jsVideo.dataset.id + "");
		if (
			videoPlayer.props.videoId === 0 ||
			videoPlayer.props.videoId !== videoId
		) {
			const jsProgressbar = this.jsProduct.querySelector<HTMLElement>(
				".jsProgressbar"
			)!;
			const that = this;
			// videoPlayer.setControlsNodes(jsProgressbar);
			videoPlayer.mount({
				productId: this.id,
				videoId: videoId,
				videoNode: jsVideo,
				progressbar: jsProgressbar,
				onChange: () => {},
				onCanplay: () => {
					this.state.isTrackLoading = false;
					this.onChange();
				},
				onPlay: () => {
					this.state.isTrackLoading = false;
					this.state.isPlaying = true;
					this.onChange();
				},
				onPause: () => {
					this.state.isTrackLoading = false;
					this.state.isPlaying = false;
					this.onChange();
				},
				onEnded: () => {},
				onWaiting: () => {
					this.state.isTrackLoading = true;
					this.onChange();
				},
				next: () => {
					that.next();
				},
			});
		}
		videoPlayer.play();
	}
	pause() {
		videoPlayer.pause();
	}
	togglePlay(jsVideo: HTMLVideoElement) {
		this.state.isPlaying ? this.pause() : this.play(jsVideo);
	}
	prev() {
		const jsVideo = this.jsProduct
			.querySelector(`.jsVideo[data-id="${videoPlayer.props.videoId}"]`)
			?.closest("li")
			?.previousElementSibling?.querySelector<HTMLVideoElement>(
				`.jsVideo`
			);
		if (jsVideo) {
			this.play(jsVideo);
		}
	}
	next() {
		const jsVideo = this.jsProduct
			.querySelector(`.jsVideo[data-id="${videoPlayer.props.videoId}"]`)
			?.closest("li")
			?.nextElementSibling?.querySelector<HTMLVideoElement>(`.jsVideo`);
		if (jsVideo) {
			this.play(jsVideo);
		}
    }
    closeProduct(){
        super.closeProduct();
        videoPlayer.pause();
    }
	render() {
		super.render();
		// playList
		const jsPlayListItems = this.jsProduct.querySelectorAll<HTMLElement>(
			`.jsPlayVideoList .jsPlayVideo`
		);

		jsPlayListItems.forEach((item) => {
			if (parseInt(item.dataset.id + "") === videoPlayer.props.videoId) {
				const jsPlayItemView = item.querySelector<HTMLElement>(
					`.jsPlayItemView`
				)!;
				// console.log("jsPlayItemView", videoPlayer.props.videoId);
				super.setControlPlayClasses(jsPlayItemView, this.state);
			}
		});
	}
}
export default ProductVideo;
